import { publicRequestPath } from '@sad5/contracts';

export function portalRequestPath(path: string): string {
  const base = import.meta.env.BASE_URL;
  if (base !== '/' && base !== '/portal/') {
    throw new Error('invalid_portal_public_base');
  }
  return publicRequestPath(base, path);
}
